module.exports = __webpack_public_path__ + "static/media/Layout14.b691608e.png";